
import {
  defineComponent,
  defineAsyncComponent,
  ref,
} from 'vue';

import type {
  Option,
  EntriesPaginator,
  Statistics,
} from '@/types';

import useEntriesNext from '@/composable/useEntries@next';

import StatisticsBy from '@/components/Statistics/Staff/StatisticsBy.vue';

export default defineComponent({
  extends: StatisticsBy,
  components: {
    // Компоненты колонок
    ClicksColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/ClicksColumn.vue')),
    ImpressionsColumn: defineAsyncComponent(() => import('@/components/Statistics/Staff/Columns/ImpressionsColumn.vue')),
    Referrer: defineAsyncComponent(() => import('@/components/Referrer.vue')),
  },
  setup(props) {
    const {
      entries: statistics,
      entriesLoading: statisticsLoading,
      entriesFetched: statisticsFetched,
      fetchEntries: fetchStatistics,
    } = useEntriesNext<Statistics>('/api/statistics/staff/getStatisticsByReferrers');

    const referrerColumnOptions: Option[] = [
      {
        value: 'referrer_uuid',
        label: 'Referrers from clicks',
      },
      {
        value: 'session_referrer_uuid',
        label: 'Referrers from requests',
      },
    ];

    const referrerColumn = ref('referrer_uuid');

    const fetchStatisticsWrapper = async (referrersPaginator: EntriesPaginator): Promise<void> => fetchStatistics({
      ...props.statisticsFilters,
      ...props.filters,
      referrer_column: referrerColumn.value,
      ...referrersPaginator,
    });

    return {
      statistics,
      statisticsLoading,
      statisticsFetched,
      referrerColumn,
      referrerColumnOptions,
      fetchStatisticsWrapper,
    };
  },
});
